module.exports = __webpack_public_path__ + "img/170.835a8a3b.jpg";